export default "__VITE_ASSET__CVr_KSqg__"